import React, { useMemo } from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { PaymentTypesEnum } from '../../shared/constants'
import { useTextResources } from '../../../language';
import { pickBy } from '../utils';



const PaymentTypesDropDown = ({ paymentTypeIds = [], ...props }) => {
    const text = useTextResources();

    const options = useMemo(() => (
        paymentTypeIds.length
            ? pickBy(PaymentTypesEnum, (key) => paymentTypeIds.includes(key))
            : PaymentTypesEnum
    ), [paymentTypeIds]);

    const data = useMemo(() => 
        Object.entries(options).reduce((acc, [key, value]) => {
            acc.push({
                text: text(key),
                value,
            });
            return acc;
        }, []),
        [options, text]
    );

    return (
        <DropDown textField='text' valueField='value' data={data} {...props} />
    );
};

PaymentTypesDropDown.propTypes = {
    paymentTypeIds: PropTypes.array,
};

export default PaymentTypesDropDown;
